import React from "react";
import styled from "styled-components";
import { Col, Row } from "react-styled-flexboxgrid";
import { Layout } from "./ui/Layout";
import { Button } from "./ui/Button";
import { colors } from "../lib/constant";
import { IconArrowR16 } from "../icons-ts";
import { fontSize } from "../lib/fonts";
import { mediaQuery } from "react-styled-mediaquery";
import { Link } from "react-scroll";
import { Title } from "./ui/Title";

const logo = require("../../assets/logo.svg");

const Container = styled(Layout)`
  padding-top: 50px;
  padding-bottom: 100px;

  ${mediaQuery("<=", "desktop")`
    padding-top: 30px;
    padding-bottom: 40px;
  `}
`;

const IntroContainer = styled(Col)`
  color: #fff;

  ${mediaQuery("<=", "tablet")`
    text-align: center;
  `}
`;

const HeaderTitle = styled.span`
  color: ${colors.secondary};
  display: block;
`;

const HeaderParagraph = styled.div`
  color: #fff;
  margin-bottom: 40px;
  ${fontSize("18px")};
  line-height: 28px;

  ${mediaQuery("<=", "phablet")`
    display: none;
  `}
`;

const LogoMobile = styled.img`
  width: 15%;
  margin: 0 auto 30px;
  display: none;

  ${mediaQuery("<=", "tablet")`
    display: block;
  `}
`;

export const HeaderIntro = () => {
  return (
    <Container>
      <Row middle="xs" between="xs">
        <IntroContainer xs={12} md={5} lg={5}>
          <LogoMobile src={logo} alt="street funders" />

          <Title htmlLevel={1} theme="titleHeaderStyle">
            <HeaderTitle>Street Funders,</HeaderTitle>
            l'application de récolte de dons face-to-face.
          </Title>

          <HeaderParagraph>
            Facile, rapide et intuitive. Simplifiez et optimisez la récolte de
            dons en face à face à l’aide d’une plateforme innovante adaptée à
            tout type d’ONG.
          </HeaderParagraph>

          <Link
            href="#"
            to="features"
            smooth={true}
            duration={700}
            offset={-80}
          >
            <Button icon={<IconArrowR16 width="16" fill="#FFF" />}>
              Découvrir Street Funders
            </Button>
          </Link>
        </IntroContainer>
      </Row>
    </Container>
  );
};
